import { useRef } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { NSBox, NSBoxString, NSRow } from 'namirasoft-site-react';
import { AccountLayout } from "../AccountLayout";
import { AccountEntities } from "../AccountEntities";
import ServiceUserAccessList from "../components/ServiceUserAccessList";

interface ServiceUserEditPageProps extends NSARouterMakerResult, AccountRouterProps
{
    isEdit: boolean;
}

function ServiceUserEditPage(props: ServiceUserEditPageProps)
{
    const NSBoxString_Name = useRef<NSBoxString>(null);

    return (
        <AccountLayout {...props}
            action={{
                title: (props.isEdit ? "Edit" : "New") + ' Service User',
                description: '',
                menus: {}
            }}
            pages={{
                entity: AccountEntities.service_user(props),
                edit: {
                    ...props,
                    ui: {
                        tab_page_edit: {
                            editor: {
                                getInputRow: () =>
                                {
                                    let name: string = NSBoxString_Name.current?.getValue() ?? "";
                                    return {
                                        name,
                                        user_category: [],
                                        user_field: [],
                                        user_tag: [],
                                    };
                                },
                                setRow: (row) =>
                                {
                                    NSBoxString_Name.current?.setValue(row.first_name);
                                }

                            }
                        },
                        getChildrenAfter: (id, row) => (
                            <ServiceUserAccessList
                                {...props}
                                service_user_id={props.isEdit ? id : null}
                                service_user_email={row?.email ?? null}
                            />
                        )
                    }
                }
            }}
        >
            <NSRow>
                <NSBoxString
                    ref={NSBoxString_Name}
                    title="Name"
                    required={true}
                    style={{ width: NSBox.width.double }}
                    info={{ link: "https://namirasoft.com/account/console-guide/service-user/#field-name" }}
                />
            </NSRow>
        </AccountLayout>
    );
}

export default ServiceUserEditPage;